// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__2J6h4","options":"AnswerScale_options__yW99j","selected":"AnswerScale_selected__1VVxE"};